'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShowMoreLink = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

require('../styles/ShowMoreLink.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  pageSize: _react2.default.PropTypes.number.isRequired,
  itemCount: _react2.default.PropTypes.number.isRequired,
  page: _react2.default.PropTypes.number.isRequired,
  handleNextPage: _react2.default.PropTypes.func.isRequired,
  loading: _react2.default.PropTypes.bool
};

var ShowMoreLink = exports.ShowMoreLink = function (_BcReactComponent) {
  _inherits(ShowMoreLink, _BcReactComponent);

  function ShowMoreLink() {
    _classCallCheck(this, ShowMoreLink);

    return _possibleConstructorReturn(this, (ShowMoreLink.__proto__ || Object.getPrototypeOf(ShowMoreLink)).apply(this, arguments));
  }

  _createClass(ShowMoreLink, [{
    key: 'render',
    value: function render() {
      // Only show "Show More" link if there are more items to show
      if (!this.props.itemCount || this.props.pageSize * this.props.page >= this.props.itemCount) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'cp-show-more-link' },
        _react2.default.createElement(
          _baseButtons.BlueCaretArrowButton,
          { handleClick: this.props.handleNextPage, 'data-test-id': 'show-more-button', isLoading: this.props.loading },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'show_more' })
        )
      );
    }
  }]);

  return ShowMoreLink;
}(_baseBcReactComponent2.default);

ShowMoreLink.propTypes = propTypes;
exports.default = ShowMoreLink;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/show-more-link/components/ShowMoreLink.component.js
// module id = 1342
// module chunks = 0